<template>
  <div id="connection-wise">
    <div class="page-header-wise">
      <div>
        <div>
          <div class="page-header-wise-title">
            <h4>Conexão QR Code</h4>
            <span>Configure a Conexão do seu dispositivo.</span>
          </div>
        </div>
      </div>
    </div>
    <div class="container-connection-wise">
      <div
        :class="[
          'card',
          'analytic-card',
          'card-connection',
          connectionStatus.clientConnected ? 'bg-c-green' : 'bg-c-red',
        ]"
      >
        <div>
          <div class="col-auto">
            <span>QR CODE</span>
          </div>
          <div
            :id="
              connectionStatus.clientConnected ? 'con-status-1' : 'con-status-2'
            "
            class="text-right"
          >
            <h4 class="m-b-5 text-white">Status de Conexão</h4>
            <h2 class="m-b-5 text-white">
              {{
                connectionStatus.clientConnected ? 'Conectado' : 'Desconectado'
              }}
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="qr-code-message ">
      <div class="form-group">
        <transition name="fade">
          <span v-if="qrCodeLoading" class="qr-code-loading-message">{{
            qrCodeLoadingMessage
          }}</span>
        </transition>

        <button
          v-if="!connectionStatus.clientConnected"
          class="btn btn-success"
          :class="{ 'qr-disabled': qrCodeLoading }"
          :disabled="qrCodeLoading"
          @click="generateQRCode"
        >
          Gerar Novo QR Code
        </button>
        <button
          v-if="connectionStatus.clientConnected"
          class="btn btn-danger"
          @click="generateQRCode"
        >
          Desconectar
        </button>

        <qrcode-vue
          :class="{ 'qr-disabled': qrCodeLoading }"
          :value="
            !connectionStatus.clientConnected ? newConnectionWapi.qrcode : ''
          "
          :size="250"
          level="L"
        />
      </div>
      <div class="send-message ">
        <div class="card-header">
          <h4>Conexão API WhatsApp InterativaChat</h4>
        </div>
        <div class="card-block">
          <h4 class="sub-title">Envie mensagens da sua API de WhatsApp:</h4>
          <div>
            <div class="form-group">
              <label class="col-sm-1 col-form-label">Telefone</label>
              <div class="col-sm-4">
                <input
                  v-model="recipient"
                  type="text"
                  class="form-control"
                  placeholder="Ex: 5531988888888"
                />
              </div>

              <div class="col-sm-5">
                <textarea
                  v-model="message"
                  rows="5"
                  class="form-control"
                  placeholder="Insira a mensagem de teste."
                />
              </div>
            </div>
          </div>

          <div class="card-block">
            <button
              @click="sendMessage"
              class="btn btn-success waves-effect waves-light"
            >
              Enviar Mensagem
            </button>
          </div>
        </div>
      </div>

      <info-modal
        v-if="showConfirmModal"
        :isVisibleConfirm="showConfirmModal"
        @close="showConfirmModal = false"
        :message="infoMessage"
      />
      <Loading
        v-if="showLoadingModalWise"
        :isLoading="isLoadingModalWise"
        :status="status"
        @close="showLoadingModalWise = false"
        :message="'KAKAK'"
      />
    </div>
  </div>
</template>
<script>
import QrcodeVue from 'qrcode.vue';
import { mapActions, mapGetters } from 'vuex';
import { io } from 'socket.io-client';
import { WAPI_URL, sendWapiTestMessageWise } from '../../../../../api/wise';
import Loading from '../../components/Loading.vue';
import InfoModal from '../../components/InfoModal.vue';
export default {
  components: {
    QrcodeVue,
    Loading,
    InfoModal,
  },
  data() {
    return {
      recipient: '',
      message: '',
      messageWhatsappConnection: '',
      intervalId: null,
      socket: null,
      qrCodeLoading: false,
      qrCodeLoadingMessage: 'Gerando QR Code',
      showConfirmModal: false,
      showLoadingModalWise: false,
      isLoadingModalWise: false,
      websocketConnected: false,
      infoMessage: '',
    };
  },
  computed: {
    ...mapGetters({
      connectionStatus: 'getConnectionStatus',
      newConnectionWapi: 'getNewConnectionWapi',
      userData: 'getUserData',
    }),
  },

  methods: {
    ...mapActions([
      'createNewWapiConnectionWise',
      'stopWapiConnectionWise',
      'loadUser',
      'loadWapiConnectionWise',
    ]),
    async sendMessage() {
      this.showLoadingModalWise = true;
      this.isLoadingModalWise = true;
      const message = {
        token: this.userData.secret,
        id: this.userData.device_id,
        body: this.message,
        to: this.recipient,
        type: 'text',
        template: null,
        credentialsMeta: null,
      };

      await sendWapiTestMessageWise({ message });
      this.infoMessage = 'Mensagem Enviada com sucesso!';
      this.isLoadingModalWise = false;
      this.showConfirmModal = true;
      this.showLoadingModalWise = false;
    },
    async generateQRCode() {
      try {
        this.qrCodeLoading = true;
        await this.stopWapiConnectionWise();
        await this.createNewWapiConnectionWise();
        this.qrCodeLoading = false;
      } catch (err) {
        this.infoMessage = 'Erro ao carregar QR Code!';
        this.showConfirmModal = true;
      }
    },
  },
  watch: {
    userData: {
      async handler(val) {
        this.socket = io(WAPI_URL);
        if (!this.websocketConnected && val && val._id) {
          this.websocketConnected = true;
          this.socket.emit('regs_account', val.secret);
          this.socket.on('whatsapp-connected', async data => {
            await this.loadUser();
            await this.loadWapiConnectionWise();
            this.infoMessage = data.message;
            this.showConfirmModal = true;
          });
        }
      },
    },
  },
};
</script>

<style scoped>
#connection-wise {
  background-color: #f2f7fb;
  font-size: 0.9375rem;
  color: #333;
  font-family: open sans, sans-serif;
  background-image: linear-gradient(rgba(255 255 255 / 0%) 240px, #f2f7fb 0%);
  width: auto;
  min-width: 100%;
  height: auto;
  padding-bottom: 200px;
}
*:focus {
  outline: none;
}

a {
  font-size: 13px;
  color: #37474f;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-outf;
}
.card {
  border-radius: 5px;
  -webkit-box-shadow: 0 0 5px 0 rgba(43, 43, 43, 0.1),
    0 11px 6px -7px rgba(43, 43, 43, 0.1);
  box-shadow: 0 0 5px 0 rgba(43, 43, 43, 0.1),
    0 11px 6px -7px rgba(43, 43, 43, 0.1);
  border: none;
  margin-bottom: 30px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.card .card-header {
  background-color: transparent;
  border-bottom: none;
  padding: 20px;
  position: relative;
}

.card .card-header.borderless {
  border-bottom: 0 solid transparent;
}

.card .card-header.borderless + .card-block,
.card .card-header.borderless + .card-block-big,
.card .card-header.borderless + .card-block-small {
  padding-top: 0;
}
.page-header-wise {
  padding: 20px 0;
  margin: 0 80px;
}
h4,
h2,
h6,
h3 {
  padding: 0;
  margin: 0;
  font-weight: 500;
  font-size: 16px;
}
h2 {
  font-size: 26px;
  font-weight: bold;
}
.page-header-wise-title {
  display: flex;
  flex-direction: column;
  padding: 40px 20px;
  font-size: 26px;
  font-weight: 400;
}
.page-header-wise-title span {
  font-size: 13px;
}
.sub-title {
  border-bottom: 1px solid rgba(204, 204, 204, 0.35);
  padding-bottom: 10px;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #2c3e50;
}
.card-container {
  display: flex;
  flex-wrap: wrap;
}
.card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin: 20px auto;
}
.card-header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.card-type {
  padding: 15px 0;
}
.form-group {
  margin-bottom: 15px;
}
.form-control {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.addFlowWise {
  display: flex;
  justify-content: center;
}
.saveFlowWise {
  padding: 10px;
  display: flex;
  justify-content: flex-start;
}

.btn {
  border-radius: 2px;
  text-transform: capitalize;
  font-size: 15px;
  padding: 0.625rem 1.1875rem;
  cursor: pointer;
  border: transparent;
}
.btn-info {
  background-color: #00bcd4;
  border-color: #00bcd4;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}
.btn-info:hover {
  background-color: #08e3ff;
  border-color: #08e3ff;
}
.btn-info:active {
  background-color: #008697;
  border-color: #008697;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}
.btn-info:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #08e3ff;
}
.btn-info.disabled {
  background-color: rgba(0, 188, 212, 0.5);
  border-color: rgba(0, 188, 212, 0.5);
}

.btn-danger {
  background-color: #ff5370;
  border-color: #ff5370;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}

.btn-danger:hover {
  background-color: #ff869a;
  border-color: #ff869a;
}

.btn-danger:active {
  background-color: #ff163d;
  border-color: #ff163d;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}

.btn-danger:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #ff869a;
}

.btn-danger.disabled {
  background-color: rgba(255, 83, 112, 0.5);
  border-color: rgba(255, 83, 112, 0.5);
}

.btn-success {
  background-color: #2ed8b6;
  border-color: #2ed8b6;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}

.btn-success:hover {
  background-color: #59e0c5;
  border-color: #59e0c5;
}

.btn-success:active {
  background-color: #20a98e;
  border-color: #20a98e;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}

.btn-success:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #59e0c5;
}

.btn-success.disabled {
  background-color: rgba(46, 216, 182, 0.5);
  border-color: rgba(46, 216, 182, 0.5);
}

.bg-c-red {
  background: #ff5370;
}
.text-c-red {
  color: #ff5370;
}
.bg-c-green {
  background: #2ed8b6;
}
.text-c-green {
  color: #2ed8b6;
}
.bg-c-yellow {
  background: #ffb64d;
}
.text-c-yellow {
  color: #ffb64d;
}
.m-b-5 {
  margin-bottom: 5px;
}
.m-b-0 {
  margin-bottom: 0;
}
.qr-code-message {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
  padding: 20px;
}
.connection-wise {
  width: auto;
  display: flex;
  flex-direction: column;
  padding: 40px;
}
.container-connection-wise {
  margin: 0 40px;
}
.card-connection-body {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  width: 100%;
}

.text-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  color: white;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
}
.form-control {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.send-message {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
}
.qr-disabled {
  filter: grayscale(100%) brightness(80%);
  pointer-events: none;
  opacity: 0.6;
  transition: all 0.3s ease;
}

.qr-code-loading-message {
  background-color: #f8d7da;
  color: #721c24;
  padding: 10px 20px;
  border-radius: 5px;
  display: inline-block;
  margin-top: 10px;
  animation: qr-code-alert 0.8s infinite;
  text-align: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@keyframes qr-code-alert {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
</style>
